import SVGIcon from "./SVGIcon.js";

type Props = {
  [props: string]: string | number;
};

const paths = [
  "M9.25,4.5A8.87,8.87,0,0,0,1,10.125a8.862,8.862,0,0,0,16.5,0A8.87,8.87,0,0,0,9.25,4.5Zm0,9.375A3.75,3.75,0,1,1,13,10.125,3.751,3.751,0,0,1,9.25,13.875Zm0-6a2.25,2.25,0,1,0,2.25,2.25A2.247,2.247,0,0,0,9.25,7.875Z",
];

const Eye = (props: Props) => (
  <SVGIcon
    className="svg-eye-icon"
    pathD={paths}
    width={18}
    height={18}
    viewBox="0 0 18 18"
    transform="translate(-0.25 -1.125)"
    {...props}
  />
);

export default Eye;
